<template>
  <v-app id="container" v-bind:class="{'bg-imagem': NavEnabled === true, 'bg-app' : !NavEnabled}">
    <!-- <header> -->
      <toolbar v-if="loadTela"></toolbar> 
      <Alertas></Alertas>
    <!-- </header> -->
    <v-content  class="" v-bind:class="{'login': NavEnabled}" lang="pt">
      <!-- && showCardCookie -->
      <div class="container-box-ck" v-if="NavEnabled && showCardCookie">
          <div class="box-cookie">
              <v-card class="bg-card contrasteExtra">
                  <v-card-text style="min-width: 250px">
                      <div v-show="!showOpcao">
                          <div>
                              <strong class="font-size-2 cl-color-dark">Controle sua privacidade</strong>
                          </div>
                          <span class="mt-5">
                              <div class="font-size-1 pt-2">
                                  Usamos cookies para melhorar sua navegação.
                              </div>
                              <router-link class="font-size-1" :to="{name: 'documentosMenu', params: {doc: 'politicaPrivacidade'}}">Política de Privacidade</router-link> -
                              <router-link class="font-size-1" :to="{name: 'documentosMenu', params: {doc: 'termoUso'}}">Termos de Uso</router-link>
                          </span>
                          <div class="mt-2 content-between">
                              <v-btn outline small color="info" @click="showOpcao = true">Opções</v-btn>
                              <v-btn outline small color="success" @click="salvaAceite()">Aceito</v-btn>
                          </div>
                      </div>
                      <div v-show="showOpcao">
                          <div class="content-between">
                              <strong class="font-size-2 cl-color-dark">Suas opções</strong>
                              <v-btn small icon style="margin-top: -5px" @click="showOpcao = false"><i class="fas fa-times"></i></v-btn>
                          </div>
                          <div class="content-between mr-3">
                              <strong class="font-size-2 pointer" @click="showNecessario = !showNecessario">Necessários (1)</strong>
                              <div class="pull-right">
                                  <v-switch style="margin-top: -8px" input-value="true" disabled></v-switch>
                              </div>
                          </div>
                          <div v-show="showNecessario" class="px-3">
                              <div class="content-between">
                                  <strong class="font-size-2">ASP.NET_SessionId</strong>
                                  <div class="pull-right pl-3">
                                      <v-switch input-value="true" disabled style="margin-top: -8px"></v-switch>
                                  </div>
                              </div>
                          </div>
                          <div class="text-center">
                            <v-btn outline small color="info" @click="salvarPreferencia()">Salvar prefências</v-btn>
                          </div>
                      </div>
                  </v-card-text>
              </v-card>
          </div>
      </div>
      <router-view class="font-default" :class="{'bodyForFooterEnd':!NavEnabled}"></router-view>
      <div id="footer" class="footer-copyright py-1 " :style="[(NavEnabled&&telaGrandeApp) ? {'display': 'inline-block'} : '']"  v-bind:class="{'alignFooter': (telaGrandeApp && NavEnabled),'text-center': (!telaGrandeApp || !NavEnabled), 'bg-copyright': !NavEnabled, 'contrasteExtra': !NavEnabled, 'footerEnd': !NavEnabled}">
        <p class="small " v-bind:class="{'contrasteExtra': NavEnabled}">Versão {{versao}} ©</p>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import toolbar from './components/MyComponents/Toolbar'
import Alertas from './components/MyComponents/Alerts'
import Vuex from '@/vuex/store'
import { postAceite } from '@/service/service_autoatendimento/autoatendimentosemtoken'
import moment from 'moment'
import $ from 'jquery'
export default {
  name: 'app',
  components: {toolbar, Alertas},
  data(){
    return{
      showOpcao: false,
      showNecessario: false,
      showToolbar: false,
      loadTela: false,
      versao: "4.2.3"
      // telaGrandeApp: false
    }
  },
  mounted(){
    Vuex.commit('SET_FONTE', 0)
    // para a primeira vez
    if(window.innerWidth >= 750)  Vuex.commit('SET_TELA', true) 
    window.onresize = ()=>{
      if(window.innerWidth >= 750) Vuex.commit('SET_TELA', true)  
      else Vuex.commit('SET_TELA', false)  
    }
    this.$nextTick(() => {
      this.loadTela = true
    })
  },
  computed: {
      NavEnabled () {
        if (this.$route.path === '/') {
          // sessionStorage.setItem("objCookiesAceito", '')
          Vuex.commit('SET_LOGIN', true)
          // this.showToolbar = true
          return true
        } else {
          if(this.$route.name !== 'documentosMenu') Vuex.commit('SET_LOGIN', false)
          
          var objCookiesAceito = sessionStorage.getItem("objCookiesAceito")
          if (objCookiesAceito && JSON.parse(objCookiesAceito).pessoa.codigo) this.postAceite(JSON.parse(objCookiesAceito))
          else Vuex.commit('SET_CARD_COOKIE', true)
          return false
        }
      },
      telaGrandeApp () {
        return Vuex.state.large
      },
      showCardCookie () {
        return Vuex.state.showCardCookie
      }
  },
  methods: {
    salvaAceite() {
        try {
          // Pegar o ip do pc
          $.getJSON("https://api64.ipify.org?format=jsonp&callback=?", (json) => {
            var data = {
              pessoa: {
                  codigo: Vuex.state.user.cdPessoa,
                  nome: Vuex.state.user.nome,
                  InDesativado: false
              },
              dtAceite: moment().format("DD/MM/YYYY HH:hh:ss"),
              inCookie: "S",
              ipAceite: json.ip
            }
            sessionStorage.setItem("objCookiesAceito", JSON.stringify(data))
            if (data.pessoa.codigo) this.postAceite(data)
            Vuex.commit('SET_CARD_COOKIE', false)
          })
        } catch (e) {
            // console.log("Erro", e)
        }
    },
    async postAceite(obj) {
        try {
          obj.pessoa.nome = Vuex.state.user.nome
          obj.pessoa.codigo = Vuex.state.user.cdPessoa
          await postAceite(obj)
          Vuex.commit('SET_CARD_COOKIE', false)
        } catch (e) {
          this.$swal.fire({
            type: 'error',
            title: 'Erro inesperado!',
            text: "Erro ao salvar aceite."
          })
        }
    },

    salvarPreferencia() {
      this.showOpcao = false
      this.showNecessario = false
    },
  }
}
</script>

<style>
#containerForFooterEnd {
  min-height: 100%;
  position: relative;
}
.bodyForFooterEnd {
  padding: 10px;
  padding-bottom: 30px; /* Height of the footer */
}
.footerEnd {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30px;
}
</style>
